import { jsx as R } from "react/jsx-runtime";
import { Breakpoints as r, ImageAndText as A } from "@nextgen-web-framework/all";
import { s as l, t as M, A as T } from "../../TextOnly-1d491347.mjs";
const v = (u) => {
  const { button: c, direction: m, link: t, textOnlyConfig: f, imgList: p } = u, o = {
    src: "",
    alt: "",
    borderRadius: 0,
    width: 0
  }, { titleConfig: n, descriptionConfig: g, theme: i, bgColor: C, rounded: a } = f, d = {
    [r.XS]: o,
    [r.SM]: o,
    [r.MD]: o,
    [r.LG]: o,
    [r.XL]: o
  };
  p.forEach(({ alt_text: b, image: e, viewport: h }) => {
    const y = {
      alt: b,
      src: e == null ? void 0 : e.url,
      borderRadius: 0
    };
    h.forEach((x) => d[x] = y);
  });
  const s = {
    direction: m,
    containerBorderRadius: a ? Number(l.roundedContainerRadius) : 0,
    imgPerViewport: d,
    button: c,
    theme: i ? M[i] : void 0,
    textOnlyConfig: {
      titleConfig: {
        ...n,
        formatType: n.formatType,
        alignment: n.alignment ? T[n.alignment] : void 0
      },
      descriptionConfig: g,
      backgroundColor: C,
      borderRadius: a ? l.roundedContainerRadius : "0"
    }
  };
  return t != null && t.url && (s.ctaConfig = {
    href: t.url,
    target: t.target ?? "_blank"
  }), /* @__PURE__ */ R(A, { ...s });
};
export {
  v as default
};
//# sourceMappingURL=ImageAndTextContainer.js.map
